const pad2 = (value) => String(value).padStart(2, '0');

const toValidDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

// Affiche la date locale dans un format HTML date (YYYY-MM-DD)
export const formatDateOnly = (utcDateString) => {
  const d = toValidDate(utcDateString);
  if (!d) return '';

  const year = d.getFullYear();
  const month = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());

  return `${year}-${month}-${day}`;
};

// Affiche l’heure locale dans un format HTML time (HH:mm)
export const formatTimeOnly = (utcDateString) => {
  const d = toValidDate(utcDateString);
  if (!d) return '';

  const hours = pad2(d.getHours());
  const minutes = pad2(d.getMinutes());

  return `${hours}:${minutes}`;
};

// Construit une date UTC ISO à partir d’une date locale + heure locale
export const toUTCISOString = (localDateString, localTimeString) => {
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(localDateString) ||
    !/^\d{2}:\d{2}$/.test(localTimeString)
  ) {
    return null;
  }

  const [year, month, day] = localDateString.split('-').map(Number);
  const [hours, minutes] = localTimeString.split(':').map(Number);

  const localDate = new Date(
    year,
    month - 1,
    day,
    hours,
    minutes,
    0,
    0
  );

  if (Number.isNaN(localDate.getTime())) {
    return null;
  }

  return localDate.toISOString();
};

export const getTodayDate = () => {
  return formatDateOnly(new Date());
};